<template>
  <div class="approvalOperation">
    <el-collapse v-model="activeNames">
      <el-collapse-item name="operation">
        <template #title>
          <span>
            <img src="../../assets/svg/approvalOperation.svg" alt="" />
            审批操作
          </span>
        </template>
        <div>
          <switchMainAudit :taskId="taskId"></switchMainAudit>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import switchMainAudit from "../auditForm/switchMainAudit.vue";
export default {
  name: "operation",
  props: {
    taskId: {
      type: String,
      default: "",
    },
  },
  components: {
    switchMainAudit,
  },
  data() {
    return {
      activeNames: ["operation"], // 全部展开
    };
  },
};
</script>
